const possibleLanguages = ['en', 'pt-BR', 'es']
const startLabel = 'start'

function getDataByPath(path) {
  const [, lang, version, category] = path.split('/')

  if (version === startLabel) {
    return { lang, version, category: startLabel }
  }
  return { lang, version, category }
}

function getIsHomePage(path) {
  const { lang, version } = getDataByPath(path)
  return possibleLanguages.includes(lang) && !version
}

module.exports = { possibleLanguages, getDataByPath, getIsHomePage }
